export const GET_THIRD_PARTY_BENEFICIARIES = "GET_THIRD_PARTY_BENEFICIARIES";
export const GET_THIRD_PARTY_BENEFICIARY = "GET_THIRD_PARTY_BENEFICIARY";
